import axios from "axios";

export const findRecipes = async (filters) => {
  try {
    const resp = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/recipe/find`, { ...filters })
    return resp
  }
  catch (err) {
    return {
      code: 1,
      err
    }
  }
}

export const saveRecipe = async ({ _id, ...params }) => {
  try {
    if (typeof _id !== 'undefined') {
      const resp = await axios.put(`${process.env.REACT_APP_API_ENDPOINT}/api/recipe/${_id}`, params)
      return resp
    }
    else {
      const resp = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/recipe`, params)
      return resp
    }

  }
  catch (err) {
    return {
      code: 1,
      err
    }
  }
};

export const getRecipe = async ({ id }) => {
  try {
    const resp = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/recipe/${id}`)
    return resp.data
  }
  catch (err) {
    return {
      code: 1,
      err
    }
  }
};

export const getRecipes = async ({ category }) => {
  try {
    const resp = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/recipe/category/${category}`)
    return resp.data
  }
  catch (err) {
    return {
      code: 1,
      err
    }
  }
};

export const deleteRecipe = async ({ id }) => {
  try {
    const resp = await axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/api/recipe/${id}`)
    return resp.data
  }
  catch (err) {
    return {
      code: 1,
      err
    }
  }
};

export const saveRecipeRecords = async (record) => {
  try {
    const resp = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/run_recipe`, record)
    return resp
  }
  catch (err) {
    return {
      code: 1,
      err
    }
  }
};

export const updateRecipeRecords = async ({ _id, ...record }) => {
  try {
    const resp = await axios.put(`${process.env.REACT_APP_API_ENDPOINT}/api/run_recipe/${_id}`, record)
    return resp
  }
  catch (err) {
    return {
      code: 1,
      err
    }
  }
}